module.exports = __webpack_public_path__ + "static/media/RafaelBonavita.38571884.jpg";